import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import BASEURL from '../../../components/helper/axiosHelper';
import useFetch from '../../../hooks/useFetch/useFetch';

const PaymentCertificate = () => {
  const { pId } = useParams();
  const { t } = useTranslation();

  // use the custom hook to fetch data from the API
  const {
    value: data,
    error,
    isLoading
  } = useFetch(`${BASEURL}/GiftService/BeneficiaryGiftService/${pId}`);

  // use the useMemo hook to memoize the data and avoid re-computing it on every render
  const tableData = useMemo(() => {
    // use destructuring to access the properties of the data
    return data?.data.map(({ beneName, beneMobile, amount, date, senderName, senderMobile }) => [
      beneName,
      beneMobile,
      amount,
      date,
      senderName,
      senderMobile
    ]);
  }, [data]);

  // use the useEffect hook to fetch data only when the component mounts or when the parameters change
  useEffect(() => {}, [pId]);

  return (
    <>
      <h1 className="text-center text-3xl font-bold py-5">Payment Certificate</h1>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>
          {t('msg_errorDueto')}: {error.message}
        </p>
      ) : (
        <div className="container mx-auto px-4 sm:px-8">
          <div className="py-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Benificiary Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Benificiary Mobile No.
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Gift Amount
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Date
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sender Name
                    </th>
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Sender Mobile No.
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {tableData?.map((row, i) => (
                    <tr key={i}>
                      {row.map((cell, j) => (
                        <td key={j} className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentCertificate;
